import { IcoMoonIcon } from '../../components/icons';
import { Button } from '../../components/button';
import { FC, ReactNode } from 'react';
import { TopDownConfetti } from '../../effects/cofettie/topdown-cofettie';

export const TriviaGameVictory: FC<{
  gohomeSlot: ReactNode;
  currentPoint?: number;
  reward?: number;
  energyCost?: number;
  energy?: number;
  isPending: boolean;
  playAgain: () => void;
  t: (key: string) => string;
}> = ({
  gohomeSlot,
  t,
  currentPoint,
  reward,
  energyCost,
  energy,
  isPending,
  playAgain,
}) => {
  return (
    <div className="relative h-full w-full">
      <div className="absolute inset-x-[-30px] bottom-0 top-5">
        <TopDownConfetti className="h-full w-full" />
      </div>
      <div className="absolute inset-0">
        <div className="flex h-full flex-col items-center pt-20">
          <h1 className="text-text300 mb-10 text-center text-[45px] font-semibold">
            {t('victory')}
          </h1>
          <div className="mb-[120px] flex w-full items-stretch justify-center gap-8 text-base">
            <div className="bg-borderColor3 border-borderColor15 flex max-w-[140px] flex-1 items-center justify-center gap-2.5 rounded-[6px] border p-[5px]">
              <IcoMoonIcon
                iconName="medal-fill"
                className="text-green700 h-6 w-6"
              />
              <div>
                <h4 className="mb-0 text-xl leading-6">{currentPoint}</h4>
                <span className="text-inlineTextColor6">{t('points')}</span>
              </div>
            </div>

            <div className="bg-borderColor3 border-borderColor15 flex max-w-[140px] flex-1 items-center justify-center gap-2.5 rounded-[6px] border p-[5px]">
              <IcoMoonIcon
                iconName="coin-stack"
                className="text-deepSkyBlue h-6 w-6"
              />
              <div>
                <h4 className="mb-0 text-xl leading-6">{reward}</h4>
                <span className="text-inlineTextColor6">{t('reward')}</span>
              </div>
            </div>
          </div>

          {energy != null && energyCost != null && energy >= energyCost && (
            <Button
              variant="blue"
              size="large"
              className="mb-5 px-10 text-sm"
              data-id="trivia_victory_page_play_again"
              onClick={playAgain}
              loading={isPending}
              loadingText={t('processing')}
            >
              {t('play_again')}
            </Button>
          )}

          {energy != null && energyCost != null && energy < energyCost && (
            <Button
              variant="blue"
              size="large"
              className="mb-5 px-10 text-sm"
              data-id="trivia_victory_page_get_more_energy"
            >
              <div className="flex items-center">
                <span className="icon-battery-low" />
                <span className="uppercase">{t('get_more_energy')}</span>
              </div>
            </Button>
          )}
          <div className="text-text600 mb-[120px] flex items-center text-sm">
            <IcoMoonIcon
              iconName="battery-charging"
              className="text-yellow800 mr-[5px]"
              style={{ width: 16, height: 16 }}
            />
            <div>
              {t('cost')} :{' '}
              <span className="text-text300">
                {energyCost || ''} {t('energy')}
              </span>
            </div>
          </div>
          {gohomeSlot}
        </div>
      </div>
    </div>
  );
};
